<template>
  <div
    class="html_medalist"
    ref="html_medalist"
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="main">
      <div class="left-box">
        <template v-if="themetype === 'A'">
          <APlayerImg
            v-for="item in datas.objectInfo"
            :key="item.playerInfos[0].playerId"
            :playerImg="item.playerInfos[0].profilePicture"
            :playerNum="item.playerInfos[0].shirtNumber * 1"
            :playerName="item.playerInfos[0].playerName"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
          ></APlayerImg>
        </template>
        <template v-else-if="themetype === 'D'">
          <DPlayerImg
            :playerInfos="datas.objectInfo[0].playerInfos"
            :countryImg="datas.objectInfo[0].teamLogo"
            :countryName="datas.objectInfo[0].teamName"
            :width="'13.88vw'"
          ></DPlayerImg>
        </template>

        <template v-else-if="themetype === 'T'">
          <DelegationImg
            v-for="item in datas.objectInfo"
            :key="item.teamId"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :width="'10vw'"
          ></DelegationImg>
        </template>
      </div>
      <div class="medalist_box" :class="themetype">
        <span class="medalist_sportEventName">
          <span
            class="medalType_icon"
            :class="datas.data.dataList[0].medalType"
          ></span>
          <span
            class="sportEventName"
            v-text="
              `${datas.data.dataList[0].disciplineName}·${datas.data.dataList[0].EventName}`
            "
          ></span>
        </span>
        <span class="medalist_matchResult">
          <span class="uncombat" v-if="sportType === 'uncombat'">
            <span class="rowItem">
              <span class="rowItem_bg"></span>
              <span
                class="rowItem_title"
                v-text="_valFormatHandler('最终成绩')"
              ></span>
              <span
                class="rowItem_val"
                v-text="
                  _valFormatHandler(
                    datas.data.dataList[0].showDataList[0].showValue
                  )
                "
              ></span>
            </span>
          </span>

          <span class="combat" v-else>
            <span class="combat_title" v-text="'最终成绩'"></span>
            <span class="combat_infor">
              <span class="combat_team combat_left">
                <span class="teamLogo">
                  <img :src="datas.data.dataList[0].showDataList[0].showLogo" />
                </span>
                <span
                  class="teamName"
                  v-text="datas.data.dataList[0].showDataList[0].showName"
                ></span>
              </span>

              <span class="combat_center">
                <span
                  class="homeScore"
                  v-text="datas.data.dataList[0].showDataList[0].showValue"
                ></span>
                <span class="vs" v-text="'-'"></span>
                <span
                  class="awayScore"
                  v-text="datas.data.dataList[0].showDataList[1].showValue"
                ></span>
              </span>
              <span class="combat_team combat_right">
                <span class="teamLogo">
                  <img :src="datas.data.dataList[0].showDataList[1].showLogo" />
                </span>
                <span
                  class="teamName"
                  v-text="datas.data.dataList[0].showDataList[1].showName"
                ></span>
              </span>
            </span>
          </span>
        </span>
      </div>
    </div>
    <!-- <div class="bottom_tip">
        *2014年开始，FIBA男篮世锦赛，已改名为FIBA男篮世界杯
      </div> -->
  </div>
</template>

<script>
// 奖牌获得者 单人 || 双人 || 团体
import APlayerImg from '../components/PlayerImg'
import DPlayerImg from '../components/DPlayerImg'
import DelegationImg from '../components/DelegationImg'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_medalist',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    APlayerImg,
    DPlayerImg,
    DelegationImg,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      // themetype: 'A', //A:单人；D:双人；T:团队
      // sportType: 'uncombat', //combat: 对抗； uncombat:非对抗
    }
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    themetype() {
      let themeType = ''
      const len = this.datas.objectInfo[0].playerInfos.length
      if (len === 0) {
        themeType = 'T'
      } else if (len === 1) {
        themeType = 'A'
      } else if (len === 2) {
        themeType = 'D'
      }
      return themeType
    },
    sportType() {
      let sportType = ''
      const len = this.datas.data.dataList[0].showDataList.length
      if (len === 1) {
        sportType = 'uncombat'
      } else if (len === 2) {
        sportType = 'combat'
      }
      return sportType
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_medalist {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 90%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      margin-right: 0.694vw;
    }
    .right-box {
      margin-left: 2.083vw;
      height: 6.25vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      .items {
        line-height: 1.388vw;
        color: rgba(51, 51, 51, 1);
        color: var(--mixtmt_greyColor_main);
      }
    }
    .medalist_box {
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      &.A {
        width: calc(100% - 7.64vw);
      }
      &.D {
        width: calc(100% - 13.88vw);
      }
      &.T {
        width: calc(100% - 10vw);
      }
      .medalist_sportEventName {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .medalType_icon {
          width: 2.083vw;
          height: 2.083vw;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &.ME_GOLD {
            background-image: var(--mixtmt_medal_gold_icon);
          }
          &.ME_SILVER {
            background-image: var(--mixtmt_medal_silver_icon);
          }
          &.ME_BRONZE {
            background-image: var(--mixtmt_medal_bronze_icon);
          }
        }
        .sportEventName {
          width: calc(100% - 2.083vw);
          font-size: 1.388vw;
          color: var(--mixtmt_greyColor2);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .medalist_matchResult {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .uncombat {
          /* font-size: 2.083vw;
          color: var(--mixtmt_greyColor3); */
          padding-top: 2.083vw;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          .rowItem {
            position: relative;
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            line-height: 2.788vw;
            margin-bottom: 2.083vw;
            &:last-child {
              margin-bottom: 0;
            }
            .rowItem_bg {
              width: 100%;
              background-color: var(--mixtmt_greyColor7);
              height: 2.788vw;
              border-radius: 1.388vw;
            }
            .rowItem_title {
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 2;
              width: 7.638vw;
              height: 100%;
              background: linear-gradient(
                90deg,
                var(--mixtmt_theme_defaultGradient_1_1) 0%,
                var(--mixtmt_theme_defaultGradient_1_2) 98%
              );
              color: var(--mixtmt_whiteColor);
              font-size: 1.11vw;
              font-weight: bold;
              text-align: center;
              border-radius: 1.388vw;
            }
            .rowItem_val {
              display: block;
              position: absolute;
              top: 0;
              right: 0;
              z-index: 2;
              width: calc(100% - 7.638vw);
              padding: 0 1.388vw;
              text-align: right;
              color: var(--mixtmt_greyColor3);
              font-size: 1.25vw;
              font-weight: bold;
            }
          }
        }

        .combat {
          padding-top: 1.38vw;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .combat_infor {
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: flex-start;
            .combat_team {
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              width: calc(50% - 4.17vw);
              .teamLogo {
                position: relative;
                width: 3.33vw;
                height: 2.22vw;
                overflow: hidden;
                &::before {
                  content: '\20';
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: 2;
                  width: 100%;
                  height: 100%;
                  border: 1px solid var(--mixtmt_greyColor5);
                }
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .teamName {
                padding-top: 0.347vw;
                width: 100%;
                word-break: break-word;
                text-align: center;
                font-size: 1.11vw;
                line-height: 1.38vw;
                color: var(--mixtmt_greyColor2);
              }
            }
            .combat_center {
              padding-top: 0.068vw;
              width: 8.34vw;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              background-color: var(--mixtmt_greyColor7);
              border-radius: 0.278vw;
              .homeScore,
              .awayScore {
                width: calc(50% - 0.972vw);
                font-size: 1.38vw;
                line-height: 2.083vw;
                color: var(--mixtmt_greyColor3);
                /* &.win {
                  color: var(--mixtmt_greyColor3);
                } */
              }
              .homeScore {
                text-align: right;
              }
              .vs {
                width: 1.944vw;
                font-size: 1.66vw;
                line-height: 2.083vw;
                color: var(--mixtmt_greyColor4);
                text-align: center;
              }
              .awayScore {
                text-align: left;
              }
            }
          }
        }
        .combat_title {
          width: 100%;
          text-align: center;
          font-size: 1.11vw;
          line-height: 2.083vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
  .bottom_tip {
    margin-top: 1.388vw;
    color: var(--mixtmt_greyColor6);
    font-size: 0.833vw;
  }
}
</style>
